/**
 * Payment DTO for use with {@link PaymentService}.
 * Represents request and response body for shop-service saved-payment endpoints.
 * @property {number} bePaymentTypeId - ID of this payment. This value is added by SAP and should not be altered.
 * @property {number} paymentTypeId - ID of the payment type associated with this payment
 * @property {string} paymentTypeDescription - Description of the payment type associated with this payment
 * @property {string} paymentName - Payment name
 * @property {string} paymentNumber - String representing the payment number (e.g. credit card number). Can be masked.
 * @property {string} expMonth - String representing the two-digit expiry month
 * @property {string} expYear - String representing the two-digit expiry year
 * @property {boolean} defaultPayment - Flag indicating whether this is the user's default payment
 * @property {string} address1 - First line of billing address
 * @property {string} address2 - Second line of billing address
 * @property {string} city - Billing city
 * @property {string} paymentPostalCode - Billing postal code
 * @property {string} district - Billing district/county
 * @property {string} region - Billing region/state
 * @property {string} countryCode - Two-letter country code of billing country
 * @property {string} ccToken - Tokenized payment number
 * @see PaymentService
 */
class PaymentDto {
    /**
     *
     * @param {{
     *  bePaymentTypeId?: number,
     *  paymentTypeId: number,
     *  paymentTypeDescription?: string,
     *  paymentName?: string,
     *  paymentNumber?: string,
     *  expMonth?: string,
     *  expYear?: string,
     *  defaultPayment?: boolean,
     *  address1?: string,
     *  address2?: string,
     *  city?: string,
     *  paymentPostalCode?: string,
     *  district?: string,
     *  region?: string,
     *  countryCode?: string,
     *  ccToken?: string,
     *  email?: string,
     *  storedCredentialsAgreementDate?: string,
     *  storedCredentialsAgreementDate?: string,
     *  storedCredentialsAgreementDate?: string
     * }} [data]
     */
    constructor(data = {}) {
        this.bePaymentTypeId = data.bePaymentTypeId;
        this.paymentTypeId = data.paymentTypeId;
        this.paymentTypeDescription = data.paymentTypeDescription;
        this.paymentName = data.paymentName;
        this.paymentNumber = data.paymentNumber;
        this.expMonth = data.expMonth;
        this.expYear = data.expYear;
        this.defaultPayment = data.defaultPayment;
        this.address1 = data.address1;
        this.address2 = data.address2;
        this.city = data.city;
        this.paymentPostalCode = data.paymentPostalCode;
        this.district = data.district;
        this.region = data.region;
        this.ccToken = data.ccToken;
        this.countryCode = data.countryCode;
        this.email = data.email;
    }
}

export default PaymentDto;
